angular.module("LeasePilot").controller("ManageBuildingsController", [
  "$scope",
  "$mdDialog",
  "$http",
  "$q",
  "BuildingService",
  "BuildingHelperService",
  function($scope, $mdDialog, $q, $http, BuildingService, BuildingHelperService) {
    $scope.init = function() {
      $scope.buildings = [];
      $scope.isLoading = true;
      $scope.error = null;

      BuildingService.get()
        .then(function(response) {
          $scope.buildings = response;
        })
        .catch(function(error) {
          console.error(error);
          $scope.error = error.message;
        })
        .finally(function() {
          $scope.isLoading = false;
        });
    };

    $scope.showCreateBuildingDialog = function() {
      zendesk.state.go("zendesk");
      zendesk.sidenav.open();
    };

    $scope.showImportCsvDialog = function() {
      $mdDialog.show({
        controller: [
          "$scope",
          "$mdDialog",
          "$http",
          function($scope, $mdDialog, $http) {
            $scope.file = null;
            $scope.isProcessing = false;
            $scope.errors = [];
            $scope.summary = null;

            $scope.onFileChange = function(element) {
              $scope.$apply(function() {
                $scope.file = element.files[0];
                $scope.errors = [];
                $scope.summary = null;
              });
            };

            $scope.cancel = function() {
              $mdDialog.cancel();
            };

            $scope.import = function() {
              if (!$scope.file || $scope.isProcessing) {
                return;
              }

              var formData = new FormData();
              formData.append("file", $scope.file);

              $scope.isProcessing = true;
              $scope.errors = [];
              $scope.summary = null;

              $http
                .post("/api/buildings/import_csv", formData, {
                  transformRequest: angular.identity,
                  headers: { "Content-Type": undefined },
                })
                .then(function(response) {
                  var data = response.data || {};
                  $scope.summary = {
                    created_count: data.created_count || 0,
                    skipped_existing_count: data.skipped_existing_count || 0,
                  };
                })
                .catch(function(error) {
                  var data = (error && error.data) || {};
                  $scope.summary = null;
                  if (data && data.errors) {
                    $scope.errors = data.errors;
                  } else if (data && data.message) {
                    $scope.errors = [{ row: null, detail: data.message }];
                  } else {
                    $scope.errors = [{ row: null, detail: "Unexpected error importing CSV" }];
                  }
                })
                .finally(function() {
                  $scope.isProcessing = false;
                });
            };
          },
        ],
        template:
          '<md-dialog aria-label="Import Buildings CSV" class="dialog-modal lp-import-csv-dialog">' +
          '  <md-toolbar class="modal-title-bar">' +
          '    <div class="md-toolbar-tool">' +
          '      <div class="row">' +
          '        <div class="col m10">' +
          '          <h2 class="modal-header">Import Buildings from CSV</h2>' +
          '        </div>' +
          '        <div class="col m2 close-container">' +
          '          <div class="close" ng-click="cancel()">' +
          '            <span aria-hidden="true">&times;</span>' +
          '          </div>' +
          '        </div>' +
          '      </div>' +
          '    </div>' +
          '  </md-toolbar>' +
          '  <md-dialog-content>' +
          '    <form>' +
          '      <div class="modal-content">' +
          '        <div style="margin-bottom: 20px;">' +
          '          <p class="md-body-1">Upload a CSV file with the expected header format.</p>' +
          '        </div>' +
          '        <div class="browse-section">' +
          '          <div class="row">' +
          '            <div class="col m1">&nbsp;</div>' +
          '            <div class="col m10">' +
          '              <div class="row">' +
          '                <div class="col m8 word-doc-name" ng-attr-title="{{ file && file.name }}">' +
          '                  <span class="inputfile">{{ (file && file.name) || "No file chosen" }}</span>' +
          '                </div>' +
          '                <div class="col m4">' +
          '                  <label class="inputfile btn blue" for="buildings-csv">Choose File</label>' +
          '                  <input id="buildings-csv" class="inputfile" type="file" accept=".csv" onchange="angular.element(this).scope().onFileChange(this)" />' +
          '                </div>' +
          '              </div>' +
          '            </div>' +
          '          </div>' +
          '        </div>' +
          '        <div class="lp-import-summary" ng-if="summary">' +
          '          <p class="md-body-1"><strong>Created:</strong> {{ summary.created_count }}</p>' +
          '          <p class="md-body-1"><strong>Skipped (already existing):</strong> {{ summary.skipped_existing_count }}</p>' +
          '        </div>' +
          '        <div class="lp-import-errors" ng-if="errors.length">' +
          '          <h3 class="md-subhead">Errors</h3>' +
          '          <ul>' +
          '            <li ng-repeat="error in errors">' +
          '              <span ng-if="error.row">Row {{ error.row }}: </span>{{ error.detail }}' +
          '            </li>' +
          '          </ul>' +
          '        </div>' +
          '      </div>' +
          '      <div class="modal-actions">' +
          '        <div class="processing-file-message" ng-class="{ processing: isProcessing }">' +
          '          <md-progress-circular class="md-hue-1" md-mode="indeterminate" md-diameter="24px"></md-progress-circular>' +
          '        </div>' +
          '        <button class="btn blue" type="button" ng-click="import()" ng-disabled="!file || isProcessing">' +
          '          <span ng-if="!isProcessing">Import</span>' +
          '          <span ng-if="isProcessing">Importing...</span>' +
          '        </button>' +
          '        <button class="btn blue-outline" type="button" ng-click="cancel()" ng-disabled="isProcessing">Cancel</button>' +
          '      </div>' +
          '    </form>' +
          '  </md-dialog-content>' +
          '</md-dialog>',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true,
      }).then(
        function() {
          // no-op; dialog closed via cancel
        },
        function() {
          // reload buildings after dialog closes to reflect any changes
          $scope.init();
        }
      );
    };

    $scope.showEditBuildingDialog = function(building) {
      window.track.event(new LoadEditBuildingEvent({
        id: building.id
      }));
      $mdDialog.show({
        controller: [
          "$scope",
          "building",
          function($scope, building) {
            $scope.building = angular.copy(building);
          },
        ],
        locals: {
          building: building,
        },
        template: '<building-form-modal type="update" building="building"></building-form-modal>',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    $scope.showDeleteBuildingDialog = function(building) {
      $mdDialog.show({
        controller: [
          "$scope",
          "building",
          function($scope, building) {
            $scope.building = angular.copy(building);
          },
        ],
        locals: {
          building: building,
        },
        template: '<delete-building-confirmation-modal building="building"></delete-building-confirmation-modal>',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    $scope.validateBeforeCreate = async function() {
      const isValid = await BuildingHelperService.validate({
        type: "create",
        name: $scope.building.displayName || "",
        dashboardName: $scope.building.dashboardName || "",
        landlordName: $scope.building.landlordName || "",
        landlordEntityType: $scope.building.landlordEntityType || "",
        landlordStateOfFormation: $scope.building.landlordStateOfFormation || "",
        streetAddress: $scope.building.streetAddress || "",
        city: $scope.building.city || "",
        county: $scope.building.county || "",
        state: $scope.building.state || "",
        zipCode: $scope.building.zipCode || "",
        municipalityType: $scope.building.municipalityType || "",
        buildingOfficeArea: $scope.building.buildingOfficeArea,
      });

      $scope.safeApply(() => {
        $scope.isValid = isValid;
      });
    };

    $scope.validateBeforeUpdate = async function() {
      const isValid = await BuildingHelperService.validate({
        type: "update",
        name: $scope.building.displayName || "",
        dashboardName: $scope.building.dashboardName || "",
        landlordName: $scope.building.landlordName || "",
        landlordEntityType: $scope.building.landlordEntityType || "",
        landlordStateOfFormation: $scope.building.landlordStateOfFormation || "",
        streetAddress: $scope.building.streetAddress || "",
        city: $scope.building.city || "",
        county: $scope.building.county || "",
        state: $scope.building.state || "",
        zipCode: $scope.building.zipCode || "",
        municipalityType: $scope.building.municipalityType || "",
        buildingOfficeArea: $scope.building.buildingOfficeArea,
      });

      $scope.safeApply(() => {
        $scope.isValid = isValid;
      });
    };

    $scope.create = async function() {
      const isValid = await BuildingHelperService.validate({
        type: "create",
        name: $scope.building.displayName || "",
        dashboardName: $scope.building.dashboardName || "",
        landlordName: $scope.building.landlordName || "",
        landlordEntityType: $scope.building.landlordEntityType || "",
        landlordStateOfFormation: $scope.building.landlordStateOfFormation || "",
        streetAddress: $scope.building.streetAddress || "",
        city: $scope.building.city || "",
        county: $scope.building.county || "",
        state: $scope.building.state || "",
        zipCode: $scope.building.zipCode || "",
        municipalityType: $scope.building.municipalityType || "",
        buildingOfficeArea: $scope.building.buildingOfficeArea,
      });

      $scope.isValid = isValid;

      if (isValid.all) {
        $scope.safeApply(() => {
          $scope.isProcessing = true;
        });
        
        const promise = BuildingHelperService.create({
          name: $scope.building.displayName,
          dashboardName: $scope.building.dashboardName,
          landlordName: $scope.building.landlordName,
          landlordEntityType: $scope.building.landlordEntityType,
          landlordStateOfFormation: $scope.building.landlordStateOfFormation,
          streetAddress: $scope.building.streetAddress,
          city: $scope.building.city,
          county: $scope.building.county,
          state: $scope.building.state,
          zipCode: $scope.building.zipCode,
          municipalityType: $scope.building.municipalityType,
          buildingOfficeArea: $scope.building.buildingOfficeArea,
        });
        
        promise.then(
          response => {
            window.location.href = "/admin_area/buildings";
          },
          error => {
            console.log(error);
            // TODO:
          }
        );
      }
    };

    $scope.update = async function() {
      const isValid = await BuildingHelperService.validate({
        type: "update",
        name: $scope.building.displayName || "",
        dashboardName: $scope.building.dashboardName || "",
        landlordName: $scope.building.landlordName || "",
        landlordEntityType: $scope.building.landlordEntityType || "",
        landlordStateOfFormation: $scope.building.landlordStateOfFormation || "",
        streetAddress: $scope.building.streetAddress || "",
        city: $scope.building.city || "",
        county: $scope.building.county || "",
        state: $scope.building.state || "",
        zipCode: $scope.building.zipCode || "",
        municipalityType: $scope.building.municipalityType || "",
        buildingOfficeArea: $scope.building.buildingOfficeArea,
      });

      $scope.isValid = isValid;

      if (isValid.all) {
        $scope.safeApply(() => {
          $scope.isProcessing = true;
        });

        const promise = BuildingHelperService.update({
          id: $scope.building.id,
          name: $scope.building.displayName,
          dashboardName: $scope.building.dashboardName,
          landlordName: $scope.building.landlordName,
          landlordEntityType: $scope.building.landlordEntityType,
          landlordStateOfFormation: $scope.building.landlordStateOfFormation,
          streetAddress: $scope.building.streetAddress,
          city: $scope.building.city,
          county: $scope.building.county,
          state: $scope.building.state,
          zipCode: $scope.building.zipCode,
          municipalityType: $scope.building.municipalityType,
          buildingOfficeArea: $scope.building.buildingOfficeArea,
        });
        
        promise.then(
          response => {
            window.track.event(new EditBuildingEvent({
              id: $scope.building.id,
            }));
            window.location.href = "/admin_area/buildings";
          },
          error => {
            console.log(error);
            // TODO:
          }
        );
      }
    };

    $scope.createSupportTicket = function() {
      zendesk.state.go("zendesk");
      zendesk.sidenav.open();
    }

    $scope.cancel = function() {
      window.track.event(new CancelEditBuildingEvent({
        id: $scope.building.id,
      }));

      window.location.href = "/admin_area/buildings";
    };

    $scope.init();
  }
]);
